import React from 'react'

const ShowSocials = ({ tourguide }) => {
    return (
        <div className="social-links d-flex gap-3 mt-2">
            {tourguide.webpage && (
                <a href={tourguide.webpage} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-globe" style={{ fontSize: '1.25rem' }}></i>
                </a>
            )}
            {tourguide.facebook && (
                <a href={tourguide.facebook} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-facebook" style={{ fontSize: '1.25rem' }}></i>
                </a>
            )}
            {tourguide.instagram && (
                <a href={tourguide.instagram} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-instagram" style={{ fontSize: '1.25rem' }}></i>
                </a>
            )}
            {tourguide.twitter && (
                <a href={tourguide.twitter} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-twitter-x" style={{ fontSize: '1.25rem' }}></i>
                </a>
            )}
            {tourguide.tiktok && (
                <a href={tourguide.tiktok} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-tiktok" style={{ fontSize: '1.25rem' }}></i>
                </a>
            )}
            {tourguide.linkedin && (
                <a href={tourguide.linkedin} target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-linkedin" style={{ fontSize: '1.25rem' }}></i>
                </a>
            )}
        </div>
    )
}

const DisplayTourGuide = ({ tourguide, locations, compact }) => {
    if (compact) {
        return (
            <div className="tourguide-compact d-flex gap-3 align-items-start p-3 bg-light rounded">
                {tourguide.avatar_url && (
                    <img 
                        src={tourguide.avatar_url} 
                        className="rounded-circle"
                        style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                        alt={tourguide.name} 
                    />
                )}
                <div>
                    <h6 className="mb-1">{tourguide.name}</h6>
                    <p className="text-muted small mb-2" style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical'
                    }}>
                        {tourguide.bio}
                    </p>
                    <ShowSocials tourguide={tourguide} />
                </div>
            </div>
        )
    }

    return (
        <div className="tourguide-profile">
            {tourguide.avatar_url && (
                <div className="mb-3">
                    <img 
                        src={tourguide.avatar_url} 
                        className="rounded"
                        style={{ maxHeight: '200px', objectFit: 'cover' }}
                        alt={tourguide.name} 
                    />
                </div>
            )}
            
            <h4 className="mb-2">{tourguide.name}</h4>
            
            {locations && locations.length > 0 && (
                locations
                    .filter(location => location.id === tourguide?.location_id)
                    .map((loc) => (
                        <div className="text-muted mb-2" key={loc.id}>
                            <i className="bi bi-geo-alt me-1"></i>
                            {loc.state 
                                ? `${loc.city}, ${loc.state}, ${loc.country}`
                                : `${loc.city}, ${loc.country}`
                            }
                        </div>
                    ))
            )}
            
            {tourguide?.languages && (
                <div className="mb-3">
                    {tourguide.languages.split(',').map((lang) => (
                        <span className="badge bg-secondary me-1" key={lang}>
                            {lang.charAt(0).toUpperCase() + lang.slice(1)}
                        </span>
                    ))}
                </div>
            )}
            
            <p className="mt-3">{tourguide.bio}</p>
            
            <div className="mt-3">
                <small className="text-muted d-block mb-2">Contact via:</small>
                <ShowSocials tourguide={tourguide} />
            </div>
        </div>
    )
}

export default DisplayTourGuide
